@for (toast of toastService.toasts(); track toast) {
<ngb-toast
    [class]="getToastClass(toast)"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (click)="toastService.remove(toast)"
    (hidden)="toastService.remove(toast)"
>
    {{ toast.message }}
</ngb-toast>
}
